import Pill from "../common/Pill";
import Arrow from "../../assets/Arrow.svg";
import X from "../../assets/X.svg";
import Linkedin from "../../assets/Linkedin.svg";
const HeroSection = () => {
    return (
        <section className=" bg-[#111219] min-h-screen flex flex-col justify-center items-center py-10">
            <div className=" flex sm:flex-row  gap-20   flex-col max-w-6xl mx-auto  items-center px-4">
                <div className="flex flex-col items-start gap-4 md:w-1/2 w-full">
                    <Pill text="contact now" backgroundColor="#FFFFFF1A" />

                    <h1 className="text-[#E1E1E1] font-semibold text-[32px] leading-[40px] md:text-[45px] md:leading-[56px] max-w-full ">
                        Ready for AgoraVoice? Let's Start A Conversation
                    </h1>

                    <p className="text-gray-300">
                        We'd love to hear from you. Reach put and let's connect.
                    </p>

                    <div className="flex space-x-3 justify-start  mt-2">
                        <a
                            href="https://x.com/AgoraVoiceAI"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Open X profile in a new tab"
                            className="p-2 border border-white rounded-xl inline-flex"
                        >
                            <img src={X} alt="X" className="h-[24px] w-[24px]" />
                        </a>
                        <a
                            href="https://www.linkedin.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Open LinkedIn profile in a new tab"
                            className="p-2 border border-white rounded-xl inline-flex"
                        >
                            <img
                                src={Linkedin}
                                alt="LinkedIn"
                                className="h-[24px] w-[24px]"
                            />
                        </a>
                    </div>
                </div>
                <div className="md:w-1/2 w-full flex justify-center items-center">
                    <div className="relative w-full   rounded-3xl border border-gray-700 overflow-hidden">
                        <div className="absolute inset-0 bg-gray-400/10"></div>
                        <div className="absolute -top-20 -right-20 w-52 h-52 bg-red-900/80 rounded-full blur-3xl"></div>
                        <div className="absolute bottom-2 left-5 w-32 h-32 bg-red-900/90 rounded-full blur-3xl"></div>
                        <div className="relative  p-8  flex flex-col justify-between">
                            <div>
                                <div className="mb-2 -ml-1">
                                    <svg
                                        className="w-8 h-8 text-white"
                                        fill="#fff"
                                        stroke="#000"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={1.5}
                                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                        />
                                    </svg>
                                </div>
                                <h2 className="text-white text-lg  mb-20">Email</h2>
                            </div>
                            <div>
                                <a
                                    href="mailto:info@agoravoice.ai"
                                    className="text-white/90 text-xl hover:text-white transition-colors"
                                >
                                    info@agoravoice.ai
                                </a>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <div className=" animate-bounce rounded-[70px] mx-auto w-fit h-[60px] px-[15px] py-[20px] mt-20 border  border-[#BF2929]">
                <img src={Arrow} alt="dow arrow" className="w-full" />
            </div>
        </section>
    );
};

export default HeroSection;
